export enum EPlatformType {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
}
